import { useState } from 'react';
import { Plus, X } from 'lucide-react';
import type { TreeEditApi } from './JsonTreeNode';

export function RemoveButton({ path, onClick }: { path: string; onClick: () => void }) {
  return (
    <button
      type="button"
      data-testid={`json-tree-remove-${path}`}
      tabIndex={-1}
      className="ml-1 inline-flex h-3.5 w-3.5 items-center justify-center rounded text-muted-foreground hover:text-destructive focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
      onClick={onClick}
      aria-label="Remove"
      title="Remove"
    >
      <X className="h-3 w-3" aria-hidden="true" />
    </button>
  );
}

export function AddChildAffordance({
  parentPath,
  containerKind,
  edit,
}: {
  parentPath: string;
  containerKind: 'object' | 'array';
  edit: TreeEditApi;
}) {
  const [keyDraft, setKeyDraft] = useState<string | null>(null);
  if (containerKind === 'array') {
    return (
      <button
        type="button"
        data-testid={`json-tree-add-element-${parentPath}`}
        tabIndex={-1}
        className="mt-0.5 inline-flex items-center gap-1 text-[11px] text-muted-foreground hover:text-foreground rounded px-1"
        onClick={() => edit.addArrayElement(parentPath)}
      >
        <Plus className="h-3 w-3" aria-hidden="true" /> element
      </button>
    );
  }
  if (keyDraft === null) {
    return (
      <button
        type="button"
        data-testid={`json-tree-add-key-${parentPath}`}
        tabIndex={-1}
        className="mt-0.5 inline-flex items-center gap-1 text-[11px] text-muted-foreground hover:text-foreground rounded px-1"
        onClick={() => setKeyDraft('')}
      >
        <Plus className="h-3 w-3" aria-hidden="true" /> key
      </button>
    );
  }
  const commit = () => {
    const trimmed = keyDraft.trim();
    if (trimmed.length > 0) {
      edit.addObjectKey(parentPath, trimmed);
    }
    setKeyDraft(null);
  };
  return (
    <input
      autoFocus
      data-testid={`json-tree-add-key-input-${parentPath}`}
      value={keyDraft}
      placeholder="key"
      onChange={(e) => setKeyDraft(e.target.value)}
      onBlur={commit}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          commit();
        } else if (e.key === 'Escape') {
          e.preventDefault();
          setKeyDraft(null);
        }
        if (e.key.startsWith('Arrow') || e.key === 'Home' || e.key === 'End') {
          e.stopPropagation();
        }
      }}
      className="mt-0.5 bg-transparent border border-border rounded px-1 text-[11px] font-mono w-24"
    />
  );
}
